<template>
    <div>
        <div :class="theme.fileUploaded" v-for="file, index in files" :key="index">
            <div>
                <v-icon-button grey @click="$emit('remove', { file, index })">
                    cancel
                </v-icon-button>
                <v-text>
                    <v-link>
                        {{file.name}}
                    </v-link>
                </v-text>
            </div>
        </div>
    
        <div :class="classes">
            <input :class="theme.inputRaw" :multiple="multiple" :disabled="disabled" @change="handleChange" :name="name" type="file" />
    
            <v-text nowrap>
                <v-icon-button grey>
                    file_upload
                </v-icon-button>
                <v-text nowrap>
                    <v-link to="javascript:;">
                        {{label}}
                    </v-link>
                </v-text>
            </v-text>
    
            <div v-if="loader" :class="theme.loader">
                <v-spinner />
            </div>
        </div>
    
        <div v-if="isErrorString" :class="[theme.caption, theme.hasError]">
            <slot name="error" :error="error">{{error}}</slot>
        </div>
        <div v-if="isErrorCollection" v-for="err, filename, index in error" :key="index" :class="[theme.caption, theme.hasError]">{{filename}}: {{err}}</div>
    
        <div :class="theme.caption">
            <slot name="caption" :caption="caption">{{caption}}</slot>
        </div>
    </div>
</template>

<script>
//    import { vSpinner } from '../Spinner';
    import { vLink } from '../Link';
    import { vIconButton } from '../Button';
    import theme from './fileUploader.scss';

    export default {
        name: 'file-uploader',
        props: {
            theme: {
                type: Object,
                default() {
                    return theme;
                }
            },
            multiple: {
                type: Boolean,
                default: false,
            },
            disabled: {
                type: Boolean,
                default: false,
            },
            label: {
                type: String,
                default: 'Загрузить',
            },
            loader: {
                type: Boolean,
                default: false,
            },
            files: {
                type: Array,
                default() {
                    return [];
                },
            },
            error: [String, Object],
            caption: String,
            accept: String,
            name: String,
        },
        data() {
            return {
                dragover: false,
            }
        },
        components: {
            vLink,
            vIconButton,
        },
        computed: {
            classes() {
                return {
                    [this.theme.fileUploader]: true,
                    [this.theme.isDragover]: this.dragover,
                }
            },
            isErrorString() {
                return typeof this.error === 'string';
            },
            isErrorCollection() {
                return typeof this.error === 'object';
            }
        },
        mounted() {
            window.addEventListener('dragover', this.handleDragOver);
            window.addEventListener('dragleave', this.handleDragLeave);
            window.addEventListener('drop', this.handleDrop);
        },
        destroyed() {
            window.removeEventListener('dragover', this.handleDragOver);
            window.removeEventListener('dragleave', this.handleDragLeave);
            window.removeEventListener('drop', this.handleDrop);
        },
        methods: {
            handleChange(e) {
                if (!e.target.files.length) {
                    return;
                }

                const files = Object.keys(e.target.files).map((i) => e.target.files[i]);
                this.$emit('input', [...files]);

                e.target.value = '';
            },
            handleDragOver() {
                this.dragover = true;
            },
            handleDragLeave() {
                this.dragover = false;
            },
            handleDrop() {
                this.dragover = false;
            },
        }
    }
</script>



// WEBPACK FOOTER //
// FileUploader.vue?d2678442